import script from "./IconCreateAssignment.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconCreateAssignment.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__